// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__TptPC","title":"InfoRow_title__2tNs2"};